import { Card } from '@/components/ui/card';
import type { DistributionRow } from '@/services/dashboard.service';

export interface RiskDistributionCardProps {
  rows: DistributionRow[];
}

export function RiskDistributionCard(props: RiskDistributionCardProps) {
  const { rows } = props;

  const getBarColor = (category: string) => {
    switch (category) {
      case 'Performing':
        return 'bg-green-600';
      case 'Default':
        return 'bg-red-600';
      case 'REO':
        return 'bg-amber-500';
      default:
        return 'bg-blue-500';
    }
  };

  const parsePct = (pct: string) => {
    const value = parseFloat(pct);
    if (Number.isNaN(value)) return 0;
    return Math.max(0, Math.min(100, value));
  };

  return (
    <Card className="p-6" data-test-id="risk-distribution-card">
      <h3
        className="text-lg font-semibold text-gray-900 mb-4"
        data-test-id="risk-distribution-title"
      >
        Loan Status Distribution
      </h3>
      <div className="space-y-3" data-test-id="risk-distribution-list">
        {rows.map((row) => {
          const pct = parsePct(row.pct_of_portfolio);
          const isPerforming = row.category === 'Performing';
          const isDefault = row.category === 'Default';

          return (
            <div
              key={row.category}
              className="flex items-center justify-between"
              data-test-id={
                isPerforming
                  ? 'risk-item-performing'
                  : isDefault
                  ? 'risk-item-default'
                  : 'risk-item'
              }
            >
              <span
                className="text-sm font-medium text-gray-700 capitalize"
                data-test-id="risk-label"
              >
                {row.category}
              </span>
              <div className="flex items-center space-x-2">
                <div
                  className="w-24 bg-gray-200 rounded-full h-2"
                  data-test-id="risk-progress-bar"
                >
                  <div
                    className={`${getBarColor(
                      row.category
                    )} h-2 rounded-full`}
                    style={{ width: `${pct}%` }}
                  ></div>
                </div>
                <span
                  className="text-sm text-gray-600 w-12 text-right"
                  data-test-id="risk-percentage"
                >
                  {pct.toFixed(1)}%
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
